import { useQuery } from '@tanstack/react-query';
import { useQuoteParams } from '@/features/quotes/context/quote-params.context';
import { planResourcesService } from '@/services/plan-resources';
import type { PlanResource } from '@/services/plan-resources/types';

export function useAssistances() {
  const { productId } = useQuoteParams();

  return useQuery({
    queryKey: ['product-assistances', productId],
    enabled: Boolean(productId),
    queryFn: async (): Promise<PlanResource[]> => {
      const result = await planResourcesService.listByProduct(productId);
      if (!result.success || !result.data) {
        throw new Error(result.error || 'Falha ao buscar assistências');
      }
      return result.data;
    },
  });
}
